/** Redux Packages. */
import { useDispatch } from 'react-redux';

/** Internal Components. */
import { createSocketData, deleteSocketData } from 'shared/lib/fetchSocket';

export default function ApplySettingControlHandler(props) {
    /** Get props from ApplySetting.js. */
    const { presetUIState, dispatch, applySettingData, setApplySettingData, setDirtyFlags, handleNoteEditActive } =
        props;

    /** Destructure state. */
    const { renderValue, presetName, mode } = presetUIState;
    /** Dispatch a function to update an edited trade partner. */
    const reducerDispatch = useDispatch();

    /** Handler for selecting a preset from the list. */
    const handlePresetList = (event) => {
        if (mode === 'note') {
            dispatch({ type: 'SET_MULTIPLE', payload: { renderValue: event.target.value } });
            handleNoteEditActive(event.target.value);
        } else {
            setDirtyFlags((prev) => ({ ...prev, isPresetDirty: false }));
            dispatch({
                type: 'SET_MULTIPLE',
                payload: { renderValue: event.target.value, presetName: '' },
            });
        }
    };

    /** Handler for adding a new preset to the list. */
    const handleAdd = () => {
        // Give alert if name is empty.
        if (presetName.trim() === '') {
            alert('Please fill out new setting name.');
        } else {
            const preset = { id: renderValue.id, name: presetName };
            createSocketData(reducerDispatch, '', 'row', 'il_preset', '', preset, () => {
                const newRenderValue = { ...renderValue, name: presetName, isNew: false };
                setApplySettingData((prev) => [newRenderValue, ...prev]);
                setDirtyFlags((prev) => ({ ...prev, isPresetDirty: false }));
                dispatch({
                    type: 'SET_MULTIPLE',
                    payload: { renderValue: newRenderValue, mode: 'view' },
                });
            });
        }
    };

    /** Handler to update existing preset data. */
    const handleUpdate = () => {
        // Give alert if name is empty.
        if (presetName.trim() === '') {
            alert('Please fill the preset name.');
            return;
        } else {
            const preset = { id: renderValue.id, name: presetName };
            createSocketData(reducerDispatch, '', 'row', 'il_preset', '', preset, () => {
                setApplySettingData((prev) => {
                    const updated = prev.map((preset) =>
                        preset.id === renderValue.id ? { ...renderValue, name: presetName } : preset
                    );

                    const matched = updated.find((p) => p.id === renderValue.id);
                    if (matched)
                        dispatch({
                            type: 'SET_MULTIPLE',
                            payload: { renderValue: matched },
                        });
                    return updated;
                });
                setDirtyFlags((prev) => ({ ...prev, isPresetDirty: false }));
                dispatch({
                    type: 'SET_MULTIPLE',
                    payload: {
                        presetName: '',
                        mode: 'view',
                    },
                });
            });
        }
    };

    /** Handler for removing a preset from the list. */
    const handleDelete = (event, id) => {
        event.stopPropagation();

        if (
            window.confirm(
                `Are you sure you want to delete this apply setting?\n※ (This will also delete its associated note.)`
            )
        ) {
            deleteSocketData(reducerDispatch, '', 'row', 'il_preset', '', { ids: [id] }, () => {
                const updatedApplySettingData = applySettingData.filter((setting) => setting.id !== id);
                setApplySettingData(updatedApplySettingData);
                dispatch({
                    type: 'SET_MULTIPLE',
                    payload: {
                        renderValue: updatedApplySettingData[0] ?? {},
                        presetName: updatedApplySettingData[0]?.name || '',
                    },
                });
            });
        }
    };

    return { handleAdd, handleDelete, handlePresetList, handleUpdate };
}
